module.exports = __webpack_public_path__ + "static/media/Orange.719c7817.png";